<div *ngIf="usuarioAutenticado" class="flex-shrink-0 p-2 menu-bg position-fixed h-100 col-2" style="overflow: hidden;">
  <div class="d-flex align-items-center mb-3 text-decoration-none border-bottom border-menu-b justify-content-center toggler-div py-2 ht-bt-side">
    <div class="d-flex justify-content-center py-3 img-logo">
      <img src="./assets/img/logo_xml.png" class="" alt="logo">
    </div>
    <div class="d-flex justify-content-center button-mobile">
      <button class="navbar-toggler text-white d-flex justify-content-end align-items-center ps-3" type="button" id="toggler-mobile" (click)="collapseMenuMobile()">
        <i class="width-icon fa fa-bars fa-lg"></i>
      </button>
    </div>
  </div>
  <div class="scroll-opt-menu">
    <ul class="list-unstyled ps-0">
      <li class="mb-1">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white d-flex col-12 justify-content-between btn-menu active-menu fs-5" id="home" (click)="ParamPend('home')">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa fa-home"></i>
            <p class="m-0 text-start">Home</p>
          </div>
        </button>
      </li>
      <li class="mb-1 submenus" *ngIf="apiLogin.listaMenuPerfil.cadastro">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white justify-content-between d-flex col-12 btn-menus fs-5" id="cadastros" data-bs-toggle="collapse" data-bs-target="#cadastros-collapse" aria-expanded="false">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa fa-plus"></i>
            <p class="m-0 text-start">Cadastros</p>
          </div>
          <i class="width-icon fa-solid fa-angle-right icon-hide"></i>
        </button>
        <div class="collapse subniveis" id="cadastros-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal small">
            <li class="btn-menu fs-6" id="cadastro-usuario" *ngIf="apiLogin.listaSubMenus[0].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-usuario')" >Usuários</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-empresa" *ngIf="apiLogin.listaSubMenus[1].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-empresa')" >Empresas</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-depara-empresas" *ngIf="apiLogin.listaSubMenus[2].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-depara-empresas')" >De-Para Empresas</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-medida" *ngIf="apiLogin.listaSubMenus[3].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-medida')" >Und. Medida</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-medida-empresa" *ngIf="apiLogin.listaSubMenus[4].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-medida-empresa')" >Und. Medida por Empresa</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-tipos-integracao" *ngIf="apiLogin.listaSubMenus[5].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-tipos-integracao')" >Tipos de Integração</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-depara-integracao" *ngIf="apiLogin.listaSubMenus[6].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-depara-integracao')" >De-Para Integração</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-cfop" *ngIf="apiLogin.listaSubMenus[7].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-cfop')" >CFOP</a>
            </li>
            <!-- <li class="btn-menu fs-6" id="cadastro-agendador-tarefas" *ngIf="apiLogin.listaSubMenus[8].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-agendador-tarefas')" >Agendador de Tarefas</a>
            </li> -->
            <li class="btn-menu fs-6" id="cadastro-fornecedores" *ngIf="apiLogin.listaSubMenus[9].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-fornecedores')" >Fornecedores</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-depara-itens" *ngIf="apiLogin.listaSubMenus[10].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-depara-itens')" >De-Para Itens</a>
            </li>
            <li class="btn-menu fs-6" id="cadastro-grupo" *ngIf="apiLogin.listaSubMenus[11].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-grupo')" >Grupos de Usuários</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="mb-1 submenus" *ngIf="apiLogin.listaMenuPerfil.regras">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white justify-content-between d-flex col-12 btn-menus fs-5" id="regras" data-bs-toggle="collapse" data-bs-target="#regras-collapse" aria-expanded="false">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa-solid fa-file-circle-exclamation"></i>
            <p class="m-0 text-start">Regras Entrada NF</p>
          </div>
          <i class="width-icon fa-solid fa-angle-right icon-hide"></i>
        </button>
        <div class="collapse subniveis" id="regras-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal small">
            <li class="btn-menu fs-6" id="cfops-interpretados" *ngIf="apiLogin.listaSubMenus[12].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cfops-interpretados')" >CFOP's Interpretados</a>
            </li>
            <li class="btn-menu fs-6" id="fornecedores-interpretados" *ngIf="apiLogin.listaSubMenus[13].hidden">
              <a class="btn-subniveis" (click)="ParamPend('fornecedores-interpretados')" >Fornecedores Interpretados</a>
            </li>
            <li class="btn-menu fs-6" id="cfops-por-empresa" *ngIf="apiLogin.listaSubMenus[14].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cfops-por-empresa')" >CFOP's por Empresa</a>
            </li>
            <li class="btn-menu fs-6" id="cfops-triangulacao" *ngIf="apiLogin.listaSubMenus[15].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cfops-triangulacao')" >CFOP's - Triangulação</a>
            </li>
            <li class="btn-menu fs-6" id="desconsidera-cfop" *ngIf="apiLogin.listaSubMenus[16].hidden">
              <a class="btn-subniveis" (click)="ParamPend('desconsidera-cfop')" >Desconsidera CFOP</a>
            </li>
            <li class="btn-menu fs-6" id="desconsidera-cfop-pedcompra" *ngIf="apiLogin.listaSubMenus[17].hidden">
              <a class="btn-subniveis" (click)="ParamPend('desconsidera-cfop-pedcompra')" >Desconsidera CFOP Ped.Compra</a>
            </li>
            <li class="btn-menu fs-6" id="fornecedores-x-rota" *ngIf="apiLogin.listaSubMenus[18].hidden">
              <a class="btn-subniveis" (click)="ParamPend('fornecedores-x-rota')" >Fornecedores X Rota</a>
            </li>
            <li class="btn-menu fs-6" id="desconsidera-cfop-xmlauto" *ngIf="apiLogin.listaSubMenus[19].hidden">
              <a class="btn-subniveis" (click)="ParamPend('desconsidera-cfop-xmlauto')" >Desconsidera CFOP XMLAuto</a>
            </li>
            <li class="btn-menu fs-6" id="desconsidera-transp-cte" *ngIf="apiLogin.listaSubMenus[20].hidden">
              <a class="btn-subniveis" (click)="ParamPend('desconsidera-transp-cte')" >Desconsidera Transportadora CTE</a>
          </ul>
        </div>
      </li>
      <li class="mb-1 submenus" *ngIf="apiLogin.listaMenuPerfil.configuracoes">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white justify-content-between d-flex col-12 btn-menus fs-5" id="configuracoes" data-bs-toggle="collapse" data-bs-target="#configuracoes-collapse" aria-expanded="false">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa fa-gears"></i>
            <p class="m-0 text-start">Configurações</p>
          </div>
          <i class="width-icon fa-solid fa-angle-right icon-hide"></i>
        </button>
        <div class="collapse subniveis" id="configuracoes-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal small">
            <li class="btn-menu fs-6" id="cadastro-agendador-tarefas" *ngIf="apiLogin.listaSubMenus[8].hidden">
              <a class="btn-subniveis" (click)="ParamPend('cadastro-agendador-tarefas')" >Agendador de Tarefas</a>
            </li>
            <li class="btn-menu fs-6" id="configuracoes-gerais" *ngIf="apiLogin.listaSubMenus[21].hidden">
              <a class="btn-subniveis" (click)="ParamPend('configuracoes-gerais')" >Gerais</a>
            </li>
            <li class="btn-menu fs-6" id="configuracoes-pastas" *ngIf="apiLogin.listaSubMenus[22].hidden">
              <a class="btn-subniveis" (click)="ParamPend('configuracoes-pastas')" >Pastas</a>
            </li>
            <li class="btn-menu fs-6" id="configuracoes-certificado" *ngIf="apiLogin.listaSubMenus[23].hidden">
              <a class="btn-subniveis" (click)="ParamPend('configuracoes-certificado')" >Certificado</a>
            </li>
            <li class="btn-menu fs-6" id="configuracoes-email" *ngIf="apiLogin.listaSubMenus[24].hidden">
              <a class="btn-subniveis" (click)="ParamPend('configuracoes-email')" >E-mail</a>
            </li>
            <li class="btn-menu fs-6" id="configuracoes-logs-debugs" *ngIf="apiLogin.listaSubMenus[25].hidden">
              <a class="btn-subniveis" (click)="ParamPend('configuracoes-logs-debugs')" >Logs e Debugs</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="mb-1 submenus" *ngIf="apiLogin.listaMenuPerfil.consultas">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white justify-content-between d-flex col-12 btn-menus fs-5" id="consultas" data-bs-toggle="collapse" data-bs-target="#consultas-collapse" aria-expanded="false">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa fa-search"></i>
            <p class="m-0 text-start">Consultas</p>
          </div>
          <i class="width-icon fa-solid fa-angle-right icon-hide"></i>
        </button>
        <div class="collapse subniveis" id="consultas-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal small">
            <li class="btn-menu fs-6" id="consulta-integracao" *ngIf="apiLogin.listaSubMenus[26].hidden">
              <a class="btn-subniveis" (click)="ParamPend('consulta-integracao')" >Integrações</a>
            </li>
            <li class="btn-menu fs-6" id="consulta-xml" *ngIf="apiLogin.listaSubMenus[27].hidden">
              <a class="btn-subniveis" (click)="ParamPend('consulta-xml')" >XML</a>
            </li>
          </ul>
        </div>
      </li>
      <li class="mb-1 submenus" *ngIf="apiLogin.listaMenuPerfil.pendencias">
        <button class="btn btn-toggle align-items-center rounded collapsed text-white justify-content-between d-flex col-12 btn-menus fs-5" id="pendencias" data-bs-toggle="collapse" data-bs-target="#pendencias-collapse" aria-expanded="false">
          <div class="separator d-flex gap-4 align-items-center">
            <i class="width-icon fa-solid fa-triangle-exclamation"></i>
            <p class="m-0 text-start">Pendências</p>
          </div>
          <i class="width-icon fa-solid fa-angle-right icon-hide"></i>
        </button>
        <div class="collapse subniveis" id="pendencias-collapse">
          <ul class="btn-toggle-nav list-unstyled fw-normal small">
            <li class="btn-menu fs-6" id="pendencias-nfe" *ngIf="apiLogin.listaSubMenus[28].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-nfe')" >NF-e</a>
            </li>
            <li class="btn-menu fs-6" id="pendencias-cte" *ngIf="apiLogin.listaSubMenus[29].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-cte')" >CT-e</a>
            </li>
            <li class="btn-menu fs-6" id="pendencias-tms" *ngIf="apiLogin.listaSubMenus[30].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-tms')" >TMS</a>
            </li>
            <li class="btn-menu fs-6" id="pendencias-nfs-e" *ngIf="apiLogin.listaSubMenus[31].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-nfs-e')" >NFS-e</a>
            </li>
            <li class="btn-menu fs-6" id="pendencias-tipo-integracao" *ngIf="apiLogin.listaSubMenus[32].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-tipo-integracao')" >Tipo Integração</a>
            </li>
            <li class="btn-menu fs-6" id="pendencias-nf-provisoria" *ngIf="apiLogin.listaSubMenus[33].hidden">
              <a class="btn-subniveis" (click)="ParamPend('pendencias-nf-provisoria')" >NF Provisória</a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
  <div class="d-flex flex-column align-items-center border-top border-menu-b justify-content-between">
    <span class="text-menu-b text-center pt-1 col" style="font-size: 12px;">v.{{versaoSistema}} - vf.{{versaoFrontEnd}}</span>
    <span class="text-menu-b text-center col" style="font-size: 12px;">Licença: {{usuarioStorage.licenca}}</span>
    <img style="width: 80px; opacity: 0.5;" class="pt-1 menu-txt" src="./assets/img/logo-visio-white.png">
  </div>
</div>

<button data-bs-toggle="modal" data-bs-target="#infoParametros" id="show-modal_menu" hidden></button>